export const APP_STORE_URL = "https://apps.apple.com/de/app/festivalplan/id6793709948";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.emergent.groupchatapp.d9o4ry&pcampaignid=web_share";
